import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { formatDate, formatTime } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { ShowTableRegisterSurvey } from "../../../components/ShowTable";
import {
  SearchBar,
  Loader,
  ButtonModifier,
  ScrollToTop,
} from "../../../components";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import {
  Paper,
  Box,
  TextField,
  Typography,
  Divider,
  Pagination,
  Button,
  ButtonGroup,
  Card,
  CardHeader,
  CardActionArea,
  CardMedia,
} from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import { Col, Row, Form } from "react-bootstrap";
import Carousel from "react-elastic-carousel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SaveIcon from "@mui/icons-material/Save";

const TampilRegisterSurvey = () => {
  const { user, setting, dispatch } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const { screenSize } = useStateContext();
  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };
  const [isFetchError, setIsFetchError] = useState(false);
  const [isRegisterSurveyExist, setIsRegisterSurveyExist] = useState(false);
  const [noRegisterSurvey, setNoRegisterSurvey] = useState("");
  const [tanggalRegisterSurvey, setTanggalRegisterSurvey] = useState("");
  const [namaRegisterSurvey, setNamaRegisterSurvey] = useState("");
  const [almRegisterSurvey, setAlmRegisterSurvey] = useState("");
  const [nopolRegisterSurvey, setNopolRegisterSurvey] = useState("");
  const [noJualRegisterSurvey, setNoJualRegisterSurvey] = useState("");
  const [gambar, setGambar] = useState([]);

  const [statusRegisterSurvey, setStatusRegisterSurvey] = useState("");
  const [tglAccRegisterSurvey, setTglAccRegisterSurvey] = useState(new Date());
  const [alasanAccRegisterSurvey, setAlasanAccRegisterSurvey] = useState("");
  const [isAcc, setIsAcc] = useState(false);
  const [tglRejectRegisterSurvey, setTglRejectRegisterSurvey] = useState(
    new Date(),
  );
  const [alasanRejectRegisterSurvey, setAlasanRejectRegisterSurvey] =
    useState("");
  const [isReject, setIsReject] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [registerSurveysData, setRegisterSurveysData] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();

  const columns = [
    { title: "No", field: "no" },
    { title: "No Register", field: "noRegisterSurvey" },
    { title: "Tanggal", field: "tanggalRegisterSurvey" },
    { title: "Nama", field: "namaRegisterSurvey" },
    { title: "Alamat", field: "almRegisterSurvey" },
    { title: "Nopol", field: "nopolRegisterSurvey" },
    { title: "No. Jual", field: "noJualRegisterSurvey" },
  ];

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  const breakPoints = [
    { width: 1, itemsToShow: 1 },
    { width: 550, itemsToShow: 3 },
    { width: 768, itemsToShow: 4 },
    { width: 1200, itemsToShow: 5 },
  ];

  useEffect(() => {
    id ? getUserById() : setIsRegisterSurveyExist(false);
  }, [id]);

  useEffect(() => {
    if (user.tipeUser === "OWN/DIREKSI" || user.tipeUser === "DESKCALL") {
      getRegisterSurveyAllCabangsData();
    } else {
      getRegisterSurveysData();
    }
  }, [page, searchTerm]);

  const getRegisterSurveyAllCabangsData = async () => {
    setLoading(true);
    try {
      const allRegisterSurveys = await axios.post(
        `${tempUrl}/registerSurveyAllCabangsPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          id: user._id,
          token: user.token,
        },
      );
      setQuery(searchTerm);
      setRegisterSurveysData(allRegisterSurveys.data.registerSurveys);
      setPage(allRegisterSurveys.data.page);
      setPages(allRegisterSurveys.data.totalPage);
      setRows(allRegisterSurveys.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getRegisterSurveysData = async () => {
    setLoading(true);
    try {
      const allRegisterSurveys = await axios.post(
        `${tempUrl}/registerSurveysPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
        {
          id: user._id,
          token: user.token,
          kodeCabang: user.cabang._id,
        },
      );
      setQuery(searchTerm);
      setRegisterSurveysData(allRegisterSurveys.data.registerSurveys);
      setPage(allRegisterSurveys.data.page);
      setPages(allRegisterSurveys.data.totalPage);
      setRows(allRegisterSurveys.data.totalRows);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getRegisterSurveysForDoc = async (isPdf, isExcel) => {
    setLoading(true);
    const allRegisterSurveyForDoc = await axios.post(
      `${tempUrl}/registerSurveysForDoc`,
      {
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      },
    );
    setLoading(false);
    if (isPdf) {
      downloadPdf(allRegisterSurveyForDoc.data);
    } else if (isExcel) {
      downloadExcel(allRegisterSurveyForDoc.data);
    }
  };

  const getUserById = async () => {
    setLoading(true);
    if (id) {
      const pickedRegisterSurvey = await axios.post(
        `${tempUrl}/registerSurveys/${id}`,
        {
          id: user._id,
          token: user.token,
        },
      );
      setIsRegisterSurveyExist(true);
      setNoRegisterSurvey(pickedRegisterSurvey.data.noRegisterSurvey);
      setTanggalRegisterSurvey(pickedRegisterSurvey.data.tanggalRegisterSurvey);
      setNamaRegisterSurvey(pickedRegisterSurvey.data.namaRegisterSurvey);
      setAlmRegisterSurvey(pickedRegisterSurvey.data.almRegisterSurvey);
      setNopolRegisterSurvey(pickedRegisterSurvey.data.nopolRegisterSurvey);
      setNoJualRegisterSurvey(pickedRegisterSurvey.data.noJualRegisterSurvey);
      setGambar(pickedRegisterSurvey.data.gambar);

      setStatusRegisterSurvey(pickedRegisterSurvey.data.statusRegisterSurvey);
      setTglAccRegisterSurvey(
        pickedRegisterSurvey.data.tglAccRegisterSurvey &&
          formatDate(pickedRegisterSurvey.data.tglAccRegisterSurvey),
      );
      setAlasanAccRegisterSurvey(
        pickedRegisterSurvey.data.alasanAccRegisterSurvey,
      );
      setTglRejectRegisterSurvey(
        pickedRegisterSurvey.data.tglRejectRegisterSurvey &&
          formatDate(pickedRegisterSurvey.data.tglRejectRegisterSurvey),
      );
      setAlasanRejectRegisterSurvey(
        pickedRegisterSurvey.data.alasanRejectRegisterSurvey,
      );
    }
    setLoading(false);
  };

  const batalRegisterSurvey = async () => {
    var date = new Date();
    var current_date =
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
    var current_time =
      date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();

    try {
      setLoading(true);
      await axios.post(`${tempUrl}/batalRegisterSurvey/${id}`, {
        noRegisterSurvey,
        tglUpdate: current_date,
        jamUpdate: current_time,
        userUpdate: user.username,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      setIsAcc(false);
      setIsReject(false);
      getUserById();
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const accRegisterSurvey = async () => {
    var date = new Date();
    var current_date =
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
    var current_time =
      date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();

    try {
      setLoading(true);
      await axios.post(`${tempUrl}/accRegisterSurvey/${id}`, {
        noRegisterSurvey,
        tglAccRegisterSurvey,
        alasanAccRegisterSurvey,
        tglUpdate: current_date,
        jamUpdate: current_time,
        userUpdate: user.username,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      setIsAcc(false);
      setIsReject(false);
      getUserById();
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const rejectRegisterSurvey = async () => {
    var date = new Date();
    var current_date =
      date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
    var current_time =
      date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();

    try {
      setLoading(true);
      await axios.post(`${tempUrl}/rejectRegisterSurvey/${id}`, {
        noRegisterSurvey,
        tglRejectRegisterSurvey,
        alasanRejectRegisterSurvey,
        tglUpdate: current_date,
        jamUpdate: current_time,
        userUpdate: user.username,
        id: user._id,
        token: user.token,
        kodeCabang: user.cabang._id,
      });
      setIsAcc(false);
      setIsReject(false);
      getUserById();
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const deleteRegisterSurvey = async (id) => {
    try {
      setLoading(true);
      await axios.post(`${tempUrl}/deleteRegisterSurvey/${id}`, {
        id: user._id,
        token: user.token,
      });
      setNoRegisterSurvey("");
      setTanggalRegisterSurvey("");
      setNamaRegisterSurvey("");
      setAlmRegisterSurvey("");
      setNopolRegisterSurvey("");
      setNoJualRegisterSurvey("");
      setLoading(false);
      navigate("/registerSurvey");
      getRegisterSurveysData();
    } catch (error) {
      console.log(error);
    }
  };

  const downloadPdf = (data) => {
    var date = new Date();
    var current_date = formatDate(date);
    var current_time = formatTime(date);
    const doc = new jsPDF();
    doc.setFontSize(12);
    doc.text(`${setting.namaPerusahaan} - ${setting.kotaPerusahaan}`, 15, 10);
    doc.text(`${setting.lokasiPerusahaan}`, 15, 15);
    doc.setFontSize(16);
    doc.text(`Daftar RegisterSurvey`, 90, 30);
    doc.setFontSize(10);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290,
    );
    doc.setFontSize(12);
    let no = 0;
    doc.autoTable({
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      columns: columns.map((col) => ({ ...col, dataKey: col.field })),
      body: data.map((col) => {
        no++;
        return { ...col, no };
      }),
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const downloadExcel = (data) => {
    const workSheet = XLSX.utils.json_to_sheet(data);
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, `RegisterSurvey`);
    // Buffer
    let buf = XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    // Binary String
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    // Download
    XLSX.writeFile(workBook, `daftarRegisterSurvey.xlsx`);
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Box>
      <ScrollToTop />
      <Typography color="#757575">Penjualan</Typography>
      <Typography variant="h4" sx={subTitleText}>
        Register Survey Penjualan
      </Typography>

      {isRegisterSurveyExist && (
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => navigate(`/registerSurvey`)}
          sx={{ marginRight: 2 }}
        >
          {"< Kembali"}
        </Button>
      )}

      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            startIcon={<PrintIcon />}
            onClick={() => getRegisterSurveysForDoc(true, false)}
          >
            CETAK
          </Button>
          <Button
            startIcon={<DownloadIcon />}
            onClick={() => getRegisterSurveysForDoc(false, true)}
          >
            EXCEL
          </Button>
        </ButtonGroup>
      </Box>
      <Box sx={buttonModifierContainer}>
        {user.tipeUser !== "OWN/DIREKSI" && user.tipeUser !== "DESKCALL" && (
          <ButtonModifier
            id={id}
            kode={isRegisterSurveyExist}
            addLink={`/registerSurvey/tambahRegisterSurvey`}
            editLink={`/registerSurvey/${id}/edit`}
            deleteUser={deleteRegisterSurvey}
            nameUser={noRegisterSurvey}
          />
        )}
      </Box>

      {isRegisterSurveyExist &&
        (user.tipeUser === "OWN/DIREKSI" || user.tipeUser === "MGR") && (
          <>
            <Box sx={buttonModifierContainer}>
              <ButtonGroup variant="contained">
                {(statusRegisterSurvey === "ACC" ||
                  statusRegisterSurvey === "REJECT") && (
                  <Form onSubmit={batalRegisterSurvey}>
                    <Button
                      color="primary"
                      sx={{ bgcolor: "primary.light", textTransform: "none" }}
                      type="submit"
                    >
                      Batal
                    </Button>
                  </Form>
                )}
                {statusRegisterSurvey !== "ACC" && (
                  <Button
                    color="success"
                    sx={{ bgcolor: "success.light", textTransform: "none" }}
                    onClick={() => {
                      setIsAcc(!isAcc);
                      setIsReject(false);
                    }}
                  >
                    Acc
                  </Button>
                )}
                {statusRegisterSurvey !== "REJECT" && (
                  <Button
                    color="error"
                    sx={{ bgcolor: "error.light", textTransform: "none" }}
                    onClick={() => {
                      setIsReject(!isReject);
                      setIsAcc(false);
                    }}
                  >
                    Reject
                  </Button>
                )}
              </ButtonGroup>
            </Box>
            {isAcc === true && (
              <div style={{ marginTop: "10px" }}>
                <Form noValidate onSubmit={accRegisterSurvey}>
                  <Paper elevation={6} sx={mainContainer}>
                    <Box sx={showDataContainer}>
                      <Box sx={showDataWrapper}>
                        <Row>
                          <Col>
                            <Form.Group
                              as={Row}
                              className="mb-3"
                              controlId="formPlaintextPassword"
                            >
                              <Form.Label column sm="5" style={textRight}>
                                Tanggal Acc <b style={colorRed}>*</b> :
                              </Form.Label>
                              <Col sm="7">
                                <DatePicker
                                  dateFormat="dd/MM/yyyy"
                                  selected={tglAccRegisterSurvey}
                                  onChange={(e) => setTglAccRegisterSurvey(e)}
                                  customInput={
                                    <TextField
                                      error={
                                        error &&
                                        tglAccRegisterSurvey === null &&
                                        true
                                      }
                                      helperText={
                                        error &&
                                        tglAccRegisterSurvey === null &&
                                        "Tanggal Acc harus diisi!"
                                      }
                                      sx={{ width: "100%" }}
                                      size="small"
                                    />
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  Tanggal Acc harus diisi!
                                </Form.Control.Feedback>
                              </Col>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Form.Group
                              as={Row}
                              className="mb-3"
                              controlId="formPlaintextPassword"
                            >
                              <Form.Label column sm="5" style={textRight}>
                                Alasan Acc :
                              </Form.Label>
                              <Col sm="7">
                                <Form.Control
                                  value={alasanAccRegisterSurvey}
                                  onChange={(e) =>
                                    setAlasanAccRegisterSurvey(
                                      e.target.value.toUpperCase(),
                                    )
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  Alasan Acc harus diisi!
                                </Form.Control.Feedback>
                              </Col>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Box sx={spacingTop}>
                          <Button
                            variant="contained"
                            startIcon={<SaveIcon />}
                            type="submit"
                          >
                            Simpan
                          </Button>
                        </Box>
                      </Box>
                      <Box sx={[showDataWrapper, secondWrapper]}></Box>
                    </Box>
                  </Paper>
                </Form>
              </div>
            )}
            {isReject === true && (
              <div style={{ marginTop: "10px" }}>
                <Form noValidate onSubmit={rejectRegisterSurvey}>
                  <Paper elevation={6} sx={mainContainer}>
                    <Box sx={showDataContainer}>
                      <Box sx={showDataWrapper}>
                        <Row>
                          <Col>
                            <Form.Group
                              as={Row}
                              className="mb-3"
                              controlId="formPlaintextPassword"
                            >
                              <Form.Label column sm="5" style={textRight}>
                                Tanggal Reject <b style={colorRed}>*</b> :
                              </Form.Label>
                              <Col sm="7">
                                <DatePicker
                                  dateFormat="dd/MM/yyyy"
                                  selected={tglRejectRegisterSurvey}
                                  onChange={(e) =>
                                    setTglRejectRegisterSurvey(e)
                                  }
                                  customInput={
                                    <TextField
                                      error={
                                        error &&
                                        tglRejectRegisterSurvey === null &&
                                        true
                                      }
                                      helperText={
                                        error &&
                                        tglRejectRegisterSurvey === null &&
                                        "Tanggal Reject harus diisi!"
                                      }
                                      sx={{ width: "100%" }}
                                      size="small"
                                    />
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  Tanggal Reject harus diisi!
                                </Form.Control.Feedback>
                              </Col>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col>
                            <Form.Group
                              as={Row}
                              className="mb-3"
                              controlId="formPlaintextPassword"
                            >
                              <Form.Label column sm="5" style={textRight}>
                                Alasan Reject :
                              </Form.Label>
                              <Col sm="7">
                                <Form.Control
                                  value={alasanRejectRegisterSurvey}
                                  onChange={(e) =>
                                    setAlasanRejectRegisterSurvey(
                                      e.target.value.toUpperCase(),
                                    )
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  Alasan Reject harus diisi!
                                </Form.Control.Feedback>
                              </Col>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Box sx={spacingTop}>
                          <Button
                            variant="contained"
                            startIcon={<SaveIcon />}
                            type="submit"
                          >
                            Simpan
                          </Button>
                        </Box>
                      </Box>
                      <Box sx={[showDataWrapper, secondWrapper]}></Box>
                    </Box>
                  </Paper>
                </Form>
              </div>
            )}
          </>
        )}

      {isRegisterSurveyExist && gambar.length !== 0 && (
        <Carousel breakPoints={breakPoints} sx={carouselStyle}>
          {gambar.length !== 0 &&
            gambar.map((img, i) => (
              <Card sx={carouselCard} elevation={10}>
                <CardActionArea>
                  <CardHeader title={`Gambar`} subheader={`No. ${i + 1}`} />
                  <CardMedia
                    component="img"
                    height="100%"
                    src={img}
                    alt={namaRegisterSurvey}
                    sx={oldImageCardMedia}
                    onClick={() => {
                      window.open(img, "_blank", "noopener,noreferrer");
                    }}
                  />
                </CardActionArea>
              </Card>
            ))}
        </Carousel>
      )}

      {isRegisterSurveyExist && (
        <>
          <Divider sx={dividerStyle} />
          <Box sx={showDataContainer}>
            <Box sx={showDataWrapper}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      No :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={noRegisterSurvey} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Tanggal :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={tanggalRegisterSurvey} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Nama :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={namaRegisterSurvey} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Alamat :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={almRegisterSurvey} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      Nopol :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={nopolRegisterSurvey} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="4" style={textRight}>
                      No. Jual :
                    </Form.Label>
                    <Col sm="8">
                      <Form.Control value={noJualRegisterSurvey} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
            </Box>
            <Box sx={[showDataWrapper, secondWrapper]}>
              <Row>
                <Col>
                  <Form.Group
                    as={Row}
                    className="mb-3"
                    controlId="formPlaintextPassword"
                  >
                    <Form.Label column sm="5" style={textRight}>
                      Status :
                    </Form.Label>
                    <Col sm="7">
                      <Form.Control value={statusRegisterSurvey} disabled />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              {statusRegisterSurvey === "ACC" && (
                <>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="5" style={textRight}>
                          Tgl. Acc :
                        </Form.Label>
                        <Col sm="7">
                          <Form.Control value={tglAccRegisterSurvey} disabled />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="5" style={textRight}>
                          Alasan Acc :
                        </Form.Label>
                        <Col sm="7">
                          <Form.Control
                            value={alasanAccRegisterSurvey}
                            disabled
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                </>
              )}
              {statusRegisterSurvey === "REJECT" && (
                <>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="5" style={textRight}>
                          Tgl. Reject :
                        </Form.Label>
                        <Col sm="7">
                          <Form.Control
                            value={tglRejectRegisterSurvey}
                            disabled
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group
                        as={Row}
                        className="mb-3"
                        controlId="formPlaintextPassword"
                      >
                        <Form.Label column sm="5" style={textRight}>
                          Alasan Reject :
                        </Form.Label>
                        <Col sm="7">
                          <Form.Control
                            value={alasanRejectRegisterSurvey}
                            disabled
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>
                </>
              )}
            </Box>
          </Box>
        </>
      )}
      <Divider sx={dividerStyle} />
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableRegisterSurvey
          currentPosts={registerSurveysData}
          tipeUser={user.tipeUser}
        />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Box>
  );
};

export default TampilRegisterSurvey;

const subTitleText = {
  fontWeight: "900",
};

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const dividerStyle = {
  pt: 4,
};

const showDataContainer = {
  mt: 4,
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const showDataWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const labelInput = {
  fontWeight: "600",
  marginLeft: 1,
};

const spacingTop = {
  mt: 4,
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const carouselStyle = {
  display: "flex",
  height: "200px",
};

const carouselCard = {
  m: "auto",
  mt: 2,
  maxWidth: "500px",
  maxHeight: "500px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "primary",
};

const oldImageCardMedia = {
  display: "flex",
  maxHeight: "150px",
};

const mainContainer = {
  padding: 3,
  borderRadius: "20px",
  margin: {
    sm: 0,
    md: 4,
  },
  marginTop: {
    xs: 4,
    md: 0,
  },
};

const colorRed = {
  color: "red",
};
